/**
 * Shared indentation constants for the navbar tree, manage-boards modal,
 * and move-to-folder modal. Levels 0-6 each get a unique indent; anything
 * deeper clamps to level 6 — by design, users nesting that deep should
 * expect the UI to lose per-level distinction.
 */
export const TREE_INDENT_BASE_PX = 8;
export const TREE_INDENT_PER_LEVEL_PX = 24;
export const TREE_INDENT_MAX_LEVEL = 6;

export function getTreeIndentPx(depth: number): number {
	const clamped = Math.min(Math.max(depth, 0), TREE_INDENT_MAX_LEVEL);
	return TREE_INDENT_BASE_PX + clamped * TREE_INDENT_PER_LEVEL_PX;
}

export function readTreeOpenState(key: string): Record<string, boolean> {
	try {
		return JSON.parse(localStorage.getItem(key) ?? "{}") as Record<
			string,
			boolean
		>;
	} catch {
		return {};
	}
}

export const NAV_TREE_OPEN_STATE_KEY = "nav-tree-open-state";
export const NAV_TREE_OPEN_FOLDER_EVENT = "illumi:nav-tree-open-folder";

export interface NavTreeOpenFolderDetail {
	folderIds: string[];
	isOpen: boolean;
}

export function requestOpenTreeFolders(
	folderIds: string[],
	isOpen = true,
	storageKey = NAV_TREE_OPEN_STATE_KEY,
): void {
	if (folderIds.length === 0) return;
	try {
		const state = readTreeOpenState(storageKey);
		for (const id of folderIds) {
			state[id] = isOpen;
		}
		localStorage.setItem(storageKey, JSON.stringify(state));
	} catch {
		// ignore storage errors
	}
	if (typeof window !== "undefined") {
		window.dispatchEvent(
			new CustomEvent<NavTreeOpenFolderDetail>(NAV_TREE_OPEN_FOLDER_EVENT, {
				detail: { folderIds, isOpen },
			}),
		);
	}
}
